import { Injectable } from '@angular/core';
import { Select } from '@ngxs/store';
import { DialogService } from '@progress/kendo-angular-dialog';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ModelModalReturnValue } from '@models-global/model-modal-return-value';
import { ClaimAuditStatusModalComponent } from '@module-claims/components/claim-audit-status-modal/claim-audit-status-modal.component';
import {
  IClaimAuditStatusUpdateParams,
  IClaimDetail
} from '@module-claims/models/claim.interface';
import {
  ClaimAuditStatusModalState,
  IClaimAuditStatusModalState
} from '@module-claims/store/claim-audit-status-modal.state';

type ClaimAuditStatusModalReturn =
  ModelModalReturnValue<IClaimAuditStatusUpdateParams>;

@Injectable()
export class ClaimAuditStatusModalService {
  @Select(ClaimAuditStatusModalState)
  stateModal$!: Observable<IClaimAuditStatusModalState>;

  constructor(private _dialogService: DialogService) {}

  open(
    claim: IClaimDetail,
    title = 'Edit Claim'
  ): Observable<ClaimAuditStatusModalReturn> {
    const modalRef = this._dialogService.open({
      title,
      content: ClaimAuditStatusModalComponent
    });
    modalRef.content.instance.claim = claim;

    const data$ = new Subject<ClaimAuditStatusModalReturn>();
    this.stateModal$.pipe(filter((data) => !!data)).subscribe((data) => {
      data$.next({
        action: data.action,
        data: data.data,
        modalRef
      });
    });

    return data$;
  }
}
